var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ops-section" },
    [
      _c(
        "el-card",
        { staticClass: "ops-page", attrs: { shadow: "never" } },
        [
          _c(
            "div",
            {
              staticClass: "ops-header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("i", { staticClass: "el-icon-setting" }),
              _vm._v(" "),
              _c("span", [_vm._v("首页探索")]),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "opsForm",
              staticClass: "ops-form",
              attrs: { model: _vm.form },
            },
            [
              _c(
                "el-card",
                { staticClass: "ops-block", attrs: { shadow: "never" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "block-title",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [_vm._v("卡卷推荐")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "coupon-cards" },
                    [
                      _vm._l(_vm.form.couponCards, function (card, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "coupon-card" },
                          [
                            _c("el-button", {
                              staticClass: "card-remove",
                              attrs: {
                                type: "text",
                                icon: "el-icon-close",
                                title: "删除此推荐项",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.removeCard(index)
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "custom-uploader" }, [
                              card.images && card.images.length > 0
                                ? _c("div", { staticClass: "image-preview" }, [
                                    _c("div", { staticClass: "preview-item" }, [
                                      _c("img", {
                                        staticClass: "preview-image",
                                        attrs: {
                                          src: card.images[0].url,
                                          alt: card.images[0].name,
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "preview-actions" },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-zoom-in preview-btn",
                                            attrs: { title: "预览" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handlePictureCardPreview(
                                                  card.images[0]
                                                )
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("i", {
                                            staticClass:
                                              "el-icon-delete preview-btn delete-btn",
                                            attrs: { title: "删除" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleRemove(
                                                  null,
                                                  [],
                                                  index
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                    ]),
                                  ])
                                : _c(
                                    "div",
                                    {
                                      staticClass: "upload-area",
                                      on: {
                                        click: function ($event) {
                                          return _vm.triggerFileInput(index)
                                        },
                                      },
                                    },
                                    [
                                      _c("input", {
                                        ref: "fileInput" + index,
                                        refInFor: true,
                                        staticStyle: { display: "none" },
                                        attrs: {
                                          type: "file",
                                          accept: "image/*",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.handleFileChange(
                                              $event,
                                              index
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("i", { staticClass: "el-icon-plus" }),
                                    ]
                                  ),
                              _vm._v(" "),
                              _c("div", { staticClass: "upload-tip1" }, [
                                _vm._v(
                                  "\n                    只能上传jpg/png文件\n                  "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "card-input",
                              attrs: {
                                placeholder: "请输入路径",
                                size: "mini",
                              },
                              model: {
                                value: card.path,
                                callback: function ($$v) {
                                  _vm.$set(card, "path", $$v)
                                },
                                expression: "card.path",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "card-input",
                              attrs: {
                                placeholder: "请输入标题",
                                size: "mini",
                              },
                              model: {
                                value: card.title,
                                callback: function ($$v) {
                                  _vm.$set(card, "title", $$v)
                                },
                                expression: "card.title",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "card-input",
                              attrs: {
                                placeholder: "请输入副标题",
                                size: "mini",
                              },
                              model: {
                                value: card.subtitle,
                                callback: function ($$v) {
                                  _vm.$set(card, "subtitle", $$v)
                                },
                                expression: "card.subtitle",
                              },
                            }),
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "add-card", on: { click: _vm.addCard } },
                        [
                          _c("div", { staticClass: "add-icon" }, [
                            _c("i", { staticClass: "el-icon-plus" }),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "add-text" }, [
                            _vm._v("添加推荐"),
                          ]),
                        ]
                      ),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "reference-links" }, [
                    _c("div", { staticClass: "link-item" }, [
                      _c("span", { staticClass: "bullet" }, [_vm._v("•")]),
                      _vm._v(" "),
                      _c("span", [_vm._v("礼券: /pages/shop/coupon/index")]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "link-item" }, [
                      _c("span", { staticClass: "bullet" }, [_vm._v("•")]),
                      _vm._v(" "),
                      _c("span", [_vm._v("礼品卡: /pages/shop/cards/index")]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "link-item" }, [
                      _c("span", { staticClass: "bullet" }, [_vm._v("•")]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          "卡详情: /pages/shop/cards/detail/index?id={id} ({id}:查阅礼品卡列表)"
                        ),
                      ]),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-card",
                { staticClass: "ops-block", attrs: { shadow: "never" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "block-title",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [_vm._v("gaga门店图")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-upload",
                    {
                      staticClass: "store-uploader",
                      attrs: {
                        action: "#",
                        "list-type": "picture-card",
                        limit: 1,
                        "auto-upload": false,
                        "on-exceed": _vm.onExceed,
                        "file-list": _vm.form.storeImages,
                        "on-preview": _vm.handlePictureCardPreview,
                        "on-remove": _vm.handleStoreRemove,
                        "on-change": _vm.handleStoreImageChange,
                        "before-upload": _vm.beforeUpload,
                        accept: "image/*",
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-plus" }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "el-upload__tip",
                          attrs: { slot: "tip" },
                          slot: "tip",
                        },
                        [
                          _vm._v(
                            "\n                只能上传jpg/png文件，且不超过2MB\n              "
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ops-actions" },
                [
                  _c("el-button", { on: { click: _vm.onReset } }, [
                    _vm._v("重置"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v("确认")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogVisible, size: "tiny" },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("img", {
            attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }